import React from "react";
import Editor from "react-simple-code-editor";
import { Box, Button, Modal, Stack, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";
// import BasicModal from "./modals/BasicModal";
import highlight from "../../../utils/highlight";

const BasicModalBox = () => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Basic Modal
        </Typography>
        <Typography variant={"body2"} color={"text.primary"}>
          The modal component provides a solid foundation for creating dialogs,
          popovers, lightboxes, or whatever else.
        </Typography>
      </Box>
      <Box sx={{ width: "80%", alignSelf: "center" }}>
        <Editor
          readOnly
          highlight={(code) => highlight(code, "js")}
          padding={30}
          style={{
            fontFamily: "monospace",
            outline: "0px",
            background: "black",
            maxHeight: 250,
            overflowY: "auto",
            caretColor: "white",
          }}
          value={
            " const [open, setOpen] = React.useState(false);\n" +
            "  const handleOpen = () => setOpen(true);\n" +
            "  const handleClose = () => setOpen(false);\n\n\n" +
            "" +
            " <Button onClick={handleOpen}>Open modal</Button>\n" +
            " <BasicModal open={open} onClose={handleClose} /> //for basic modal\n" +
            " <BasicModalWithHeaderComp open={open} onClose={handleClose} title='Header'/> //for basic modal with header\n" +
            " <DeleteWarningModal open={open} onClose={handleClose} /> //for basic Delete Warning Modal"
          }
        />
        <PreviewAndEditor
          height={"300px"}
          language="js"
          value={`
            import { useState } from "react"
            import { Button, Modal } from "convertupleads-theme"
  
            export default function PreviewModal() {
              const [open, setOpen] = useState(false)
              return (
                <div>
                  <Button onClick={() => setOpen(true)}>
                    Open modal
                  </Button>
                  <Modal open={open} onClose={() => setOpen(false)}>{/*content*/}</Modal>
                </div>
              )
            }    
            `}
        >
          <Button onClick={handleOpen}>Open modal</Button>
          <Modal
            open={open}
            onClose={handleClose}
            autoScroll={true}
            maxWidth={500}
          >
            <></>
          </Modal>
        </PreviewAndEditor>
      </Box>
    </Stack>
  );
};

export default BasicModalBox;
